import type { Messages } from "./nl";

// The words of the customer portal, German, addressing the customer with "Sie".

export const de: Messages = {
  "portal.name": "Kundenportal",

  "common.cancel": "Abbrechen",
  "common.save": "Speichern",
  "common.copy": "Kopieren",
  "common.copied": "Kopiert",
  "common.backToSignIn": "Zurück zur Anmeldung",

  "language.choose": "Sprache wählen",

  "nav.label": "Portal",
  "nav.home": "Zu den Sendungen",
  "nav.shipments": "Sendungen",
  "nav.order": "Auftrag erfassen",
  "nav.stock": "Bestand",
  "nav.warehouseOrders": "Lageraufträge",

  "login.title": "Anmelden",
  "login.lead": "Kundenportal von Willems Logistics",
  "login.email": "E-Mail-Adresse",
  "login.password": "Passwort",
  "login.forgot": "Passwort vergessen?",
  "login.submit": "Anmelden",
  "login.noAccount": "Noch kein Konto? Ihr Ansprechpartner bei Willems lädt Sie ein.",

  "code.title": "Code aus der App",
  "code.lead": "Öffnen Sie die Authenticator-App und geben Sie den Code bei Willems Logistics ein.",
  "code.leadApp": "Öffnen Sie die App. Unter Willems Logistics steht ein sechsstelliger Code.",
  "code.label": "Code aus der App",
  "code.noPhone": "Telefon nicht zur Hand? Verwenden Sie einen Wiederherstellungscode",
  "code.changes": "Der Code ändert sich alle 30 Sekunden. Ein gerade abgelaufener Code funktioniert auch noch.",
  "code.timeTip":
    "Code stimmt nicht? Prüfen Sie, ob die Uhrzeit auf Ihrem Telefon automatisch eingestellt wird. Ist sie von Hand eingestellt, geht der Code nach.",
  "code.scanAgain": "Erneut scannen",
  "code.confirm": "Bestätigen",

  "recovery.back": "Zurück zum Code",
  "recovery.title": "Mit einem Wiederherstellungscode anmelden",
  "recovery.lead": "Verwenden Sie einen der acht Codes, die Sie bei der Aktivierung Ihres Kontos aufbewahrt haben. Jeder Code funktioniert einmal.",
  "recovery.label": "Wiederherstellungscode",
  "recovery.thenPhone": "Nach der Anmeldung bittet Sie das Portal sofort, ein neues Telefon zu verbinden. Ihre alte Verbindung entfällt dann.",
  "recovery.noneLeft":
    "Keine Codes mehr? Wenden Sie sich an Ihren Ansprechpartner bei Willems. Willems richtet Ihren Zugang neu ein: Sie erhalten eine neue Einladung und wählen erneut ein Passwort und ein Telefon.",

  "locked.title": "Kurz gesperrt",
  "locked.text":
    "Ihr Konto ist für eine Viertelstunde gesperrt. Fünfmal hintereinander wurde ein falsches Passwort oder ein falscher Code eingegeben. Anmelden ist wieder um {{time}} möglich.",
  "locked.notYou": "Waren Sie das nicht selbst? Ändern Sie dann nach der Anmeldung Ihr Passwort, über das Menü unter Ihrem Namen.",

  "forgot.title": "Passwort vergessen",
  "forgot.lead": "Sie erhalten eine E-Mail mit einem Link, um ein neues Passwort zu wählen.",
  "forgot.submit": "Link senden",
  "forgot.sent":
    "Sehen Sie in Ihre E-Mails. Ist diese Adresse bei uns bekannt, ist der Link in wenigen Minuten da. Er funktioniert eine Stunde. Keine E-Mail? Sehen Sie auch im Spam-Ordner nach.",
  "forgot.codeToo":
    "Für das neue Passwort fragt das Portal auch den Code aus Ihrer Authenticator-App. Ein Postfach allein reicht also nicht, um in Ihr Konto zu kommen.",

  "reset.title": "Neues Passwort",
  "reset.submit": "Speichern und anmelden",
  "reset.elsewhere": "Nach dem Speichern werden Sie überall sonst abgemeldet.",
  "reset.noPhone": "Telefon auch verloren? Dann können Sie hier kein neues Passwort wählen. Ihr Ansprechpartner bei Willems richtet Ihren Zugang neu ein.",

  "link.invalidTitle": "Dieser Link funktioniert nicht mehr",
  "link.invalidInvitation":
    "Der Link in der Einladung funktioniert einmal, sieben Tage lang. Ist Ihr Konto schon eingerichtet? Dann melden Sie sich an. Sonst bitten Sie Ihren Ansprechpartner bei Willems um eine neue Einladung.",
  "link.invalidReset": "Der Link für ein neues Passwort funktioniert einmal, eine Stunde lang. Fordern Sie einen neuen Link an.",
  "link.toSignIn": "Zur Anmeldung",
  "link.askNew": "Neuen Link anfordern",

  "password.new": "Neues Passwort",
  "password.current": "Aktuelles Passwort",
  "password.repeat": "Noch einmal",
  "password.ruleLength": "Mindestens 10 Zeichen",
  "password.ruleEmail": "Nicht Ihre E-Mail-Adresse",
  "password.tooShort": "Wählen Sie ein Passwort mit mindestens 10 Zeichen.",
  "password.sameAsEmail": "Ihre E-Mail-Adresse kann kein Passwort sein.",
  "password.sameAsCurrent": "Wählen Sie ein anderes Passwort als das aktuelle.",
  "password.notSame": "Die beiden Passwörter sind nicht gleich.",

  "activate.label": "Konto aktivieren",
  "activate.steps": "Schritte",
  "activate.stepPassword": "Passwort",
  "activate.stepApp": "App verbinden",
  "activate.stepCode": "Code prüfen",
  "activate.stepCodes": "Wiederherstellungscodes",
  "activate.passwordTitle": "Wählen Sie ein Passwort",
  "activate.passwordLead": "Für {{email}} · {{companies}}",
  "activate.passwordTip": "Tipp: Einen Satz aus ein paar Wörtern merken Sie sich leichter als einen Code.",
  "activate.startedBefore": "Sie hatten hier schon begonnen. Wählen Sie erneut ein Passwort; danach verbinden Sie die App.",
  "activate.nextApp": "Weiter: App verbinden",
  "activate.nextCode": "Weiter: Code prüfen",
  "activate.codeTitle": "Geben Sie den Code aus der App ein",
  "activate.linked": "Die App ist verbunden.",
  "activate.toPortal": "Zum Portal",

  "app.title": "Verbinden Sie die Authenticator-App auf Ihrem Telefon",
  "app.lead":
    "Bei jeder Anmeldung fragt das Portal einen sechsstelligen Code aus dieser App. So kann sich niemand anders anmelden, auch nicht mit Ihrem Passwort.",
  "app.step1": "Installieren Sie eine Authenticator-App",
  "app.step1Help":
    "Zum Beispiel Microsoft Authenticator oder Google Authenticator: kostenlos im App Store oder bei Google Play. Haben Sie schon eine, verwenden Sie diese.",
  "app.step2": "Tippen Sie in der App auf +",
  "app.step2Help": "Wählen Sie Konto hinzufügen und danach QR-Code scannen. Steht dort Geschäfts- oder Schulkonto, wählen Sie anderes Konto.",
  "app.step3": "Richten Sie die Kamera auf den QR-Code daneben",
  "app.step3Help": "In der App erscheint Willems Logistics mit einem sechsstelligen Code.",
  "app.keyDesk": "Scannen klappt nicht? Wählen Sie in der App Code eingeben und tippen Sie diesen Schlüssel ab:",
  "app.keyPhone": "Passiert nichts? Kopieren Sie den Schlüssel und fügen Sie ihn in der App bei Code eingeben ein:",
  "app.phoneInstall": "Installieren Sie Microsoft Authenticator oder Google Authenticator, falls Sie diese noch nicht haben.",
  "app.phoneAdd": "Zur Authenticator-App hinzufügen",
  "app.phoneBack": "Kommen Sie danach zu diesem Bildschirm zurück und geben Sie den sechsstelligen Code ein.",
  "app.qrLabel": "QR-Code, um das Konto zur Authenticator-App hinzuzufügen",
  "app.print": "Diese Anleitung drucken",

  "codes.title": "Bewahren Sie Ihre Wiederherstellungscodes auf",
  "codes.lead":
    "Verlieren Sie Ihr Telefon, oder bekommen Sie ein neues? Dann melden Sie sich mit einem dieser Codes an und verbinden danach das neue Telefon. Jeder Code funktioniert einmal.",
  "codes.leadNew": "Das sind Ihre neuen Wiederherstellungscodes. Die bisherigen Codes funktionieren nicht mehr. Jeder Code funktioniert einmal.",
  "codes.listLabel": "Wiederherstellungscodes",
  "codes.download": "Herunterladen",
  "codes.print": "Drucken",
  "codes.where":
    "Bewahren Sie sie nicht nur auf demselben Telefon auf: in der Schublade Ihres Schreibtischs oder im Passwort-Tresor Ihres Unternehmens. Sie sehen sie hier nur einmal; neue können Sie später im Menü unter Ihrem Namen erstellen.",
  "codes.kept": "Ich habe meine Wiederherstellungscodes aufbewahrt",
  "codes.noneLeft": "Keine Codes mehr und Telefon verloren? Dann richtet Willems Ihren Zugang neu ein.",
  "codes.fileName": "willems-wiederherstellungscodes.txt",
  "codes.fileHead": "Willems Logistics - Kundenportal",
  "codes.fileFor": "Wiederherstellungscodes für {{email}}",
  "codes.fileMade": "Erstellt am {{at}}",
  "codes.fileOnce": "Jeder Code funktioniert einmal.",

  "phone.title": "Ein neues Telefon verbinden",
  "phone.stepLabel": "Neues Telefon",
  "phone.lead": "Ihr jetziges Telefon funktioniert weiter, bis der Code des neuen Telefons stimmt.",
  "phone.leadForced":
    "Sie haben sich mit einem Wiederherstellungscode angemeldet. Verbinden Sie jetzt das Telefon, mit dem Sie sich künftig anmelden; die alte Verbindung entfällt dann.",
  "phone.leadPassword": "Geben Sie zuerst Ihr Passwort ein. Ihr jetziges Telefon funktioniert weiter, bis der Code des neuen Telefons stimmt.",
  "phone.next": "Weiter: App verbinden",
  "phone.done": "Das neue Telefon ist verbunden. Auf anderen Geräten sind Sie abgemeldet.",
  "phone.doneTitle": "Fertig",
  "phone.doneLead_one": "Sie haben noch {{count}} Wiederherstellungscode. Erstellen Sie neue Codes im Menü unter Ihrem Namen.",
  "phone.doneLead_other": "Sie haben noch {{count}} Wiederherstellungscodes. Neue können Sie im Menü unter Ihrem Namen erstellen.",

  "company.title": "Für welches Unternehmen arbeiten Sie jetzt?",
  "company.lead_one": "Sie haben Zugang für {{count}} Unternehmen.",
  "company.lead_other":
    "Sie haben Zugang für {{count}} Unternehmen. Sie sehen immer ein Unternehmen zugleich; wechseln können Sie oben, neben Ihrem Namen.",
  "company.signedInAs": "Angemeldet als {{name}} · {{email}}",
  "company.switch": "Anderes Unternehmen wählen",
  "company.youWorkFor": "Sie arbeiten für",
  "company.switchNote": "Beim Wechseln lädt das Portal neu, nur mit den Daten dieses Unternehmens.",

  "user.menu": "Benutzermenü",
  "user.language": "Sprache",
  "user.password": "Passwort ändern",
  "user.phone": "Neues Telefon verbinden",
  "user.recoveryCodes": "Neue Wiederherstellungscodes",
  "user.signOut": "Abmelden",

  "account.passwordDone": "Ihr Passwort wurde geändert. Auf anderen Geräten sind Sie abgemeldet.",
  "account.passwordElsewhere": "Nach dem Speichern werden Sie überall sonst abgemeldet.",
  "account.backToPortal": "Zurück zum Portal",
  "account.codesLead_one": "Sie haben noch {{count}} Wiederherstellungscode. Erstellen Sie acht neue; dieser funktioniert danach nicht mehr.",
  "account.codesLead_other":
    "Sie haben noch {{count}} Wiederherstellungscodes. Erstellen Sie acht neue; die Codes, die Sie jetzt haben, funktionieren danach nicht mehr.",
  "account.codesSubmit": "Neue Codes erstellen",

  "expired.title": "Sie wurden abgemeldet",
  "expired.text": "Nach 8 Stunden meldet das Portal Sie ab, und auch wenn Ihr Passwort oder Ihr Zugang geändert wurde.",
  "expired.again": "Erneut anmelden",

  "problem.notFound": "Diese Seite gibt es nicht, oder Sie haben keinen Zugang",
  "problem.notFoundText": "Kamen Sie über einen Link eines Kollegen? Dann gehört er vielleicht zu einem anderen Unternehmen.",
  "problem.toShipments": "Zu den Sendungen",
  "problem.failure": "Bei Willems ist etwas schiefgegangen",
  "problem.failureText": "Bitte versuchen Sie es erneut. Klappt es nicht, wenden Sie sich an Ihren Ansprechpartner.",
  "problem.failureCode": "Bitte versuchen Sie es erneut. Klappt es nicht, nennen Sie Ihrem Ansprechpartner den Code {{code}}.",
  "problem.retry": "Erneut versuchen",

  "shipment.eyebrow": "Sendung",
  "shipment.yourReference": "Ihre Referenz {{reference}}",
  "shipment.entered.portal": "Im Portal erfasst, {{at}}",
  "shipment.entered.edi": "Per EDI eingegangen, {{at}}",
  "shipment.entered.willems": "Von Willems erfasst, {{at}}",
  "shipment.ownPage": "Eigene Seite",
  "shipment.close": "Schließen",
  "shipment.status.waiting": "Wartet auf Willems",
  "shipment.status.rejected": "Abgelehnt",
  "shipment.status.confirmed": "Bestätigt",
  "shipment.status.planned": "Eingeplant",
  "shipment.status.in_transit": "Unterwegs",
  "shipment.status.delivered": "Zugestellt",
  "shipment.status.refused": "Verweigert",
  "shipment.status.cancelled": "Storniert",
  "shipment.issue.shortage": "Fehlmenge",
  "shipment.issue.damage": "Schaden",
  "shipment.waiting.title": "Willems prüft diesen Auftrag, bevor er weitergeht.",
  "shipment.waiting.address": "Eine Adresse ist für Willems neu. Willems prüft sie und legt sie an.",
  "shipment.waiting.stops": "Die Reihenfolge von Laden und Entladen stimmt nicht. Willems korrigiert sie oder nimmt Kontakt mit Ihnen auf.",
  "shipment.waiting.duplicate": "Es scheint schon einen gleichen Auftrag zu geben. Willems prüft, ob es derselbe ist.",
  "shipment.waiting.too_late": "Der Auftrag kam nach dem Annahmeschluss. Willems prüft, ob es noch klappt.",
  "shipment.waiting.account": "Ihr Unternehmen ist bei Willems noch nicht ganz eingerichtet. Willems erledigt das und gibt den Auftrag dann frei.",
  "shipment.waiting.change": "Eine Änderung ist eingegangen, die Willems noch prüft.",
  "shipment.waiting.announced": "Der Auftrag ist angekündigt. Willems wartet auf die endgültigen Angaben.",
  "shipment.waiting.check": "Willems prüft den Auftrag.",
  "shipment.rejected": "Willems kann diesen Auftrag nicht ausführen. Bitte wenden Sie sich an Ihren Ansprechpartner.",
  "shipment.cancelled": "Diese Sendung wurde storniert.",
  "shipment.refused": "Der Empfänger hat die Ware verweigert.",
  "shipment.issueSentence.shortage": "Mit Fehlmenge zugestellt.",
  "shipment.issueSentence.damage": "Mit Schaden zugestellt.",
  "shipment.remark": "Anmerkung: {{remark}}",
  "shipment.late": "Nach dem Zeitfenster zugestellt.",
  "shipment.afterWindow": "nach dem Zeitfenster",
  "shipment.progress": "Verlauf",
  "shipment.step.entered": "Erfasst",
  "shipment.step.confirmed": "Bestätigt",
  "shipment.step.planned": "Eingeplant",
  "shipment.step.loaded": "Geladen",
  "shipment.step.delivered": "Zugestellt",
  "shipment.step.completed": "Abgeschlossen",
  "shipment.load": "Laden",
  "shipment.unload": "Entladen",
  "shipment.placeReference": "Referenz {{reference}}",
  "shipment.loadedAt": "Geladen {{at}}",
  "shipment.deliveredAt": "Entladen {{at}}",
  "shipment.cargo.title": "Ladung",
  "shipment.cargo.description": "Beschreibung",
  "shipment.cargo.pallets": "Paletten",
  "shipment.cargo.weight": "Gewicht",
  "shipment.cargo.loadingMeters": "Lademeter",
  "shipment.cargo.adr": "ADR",
  "shipment.cargo.yes": "Ja",
  "shipment.cargo.temperature": "Temperatur",
  "shipment.documents": "Dokumente",
  "shipment.cmrNotYet": "CMR noch nicht eingegangen",
  "shipment.cmrAfterDelivery": "Der unterschriebene CMR erscheint hier nach der Zustellung.",
  "shipment.cmrAfterHandIn": "Der unterschriebene CMR erscheint hier, sobald er bei Willems eingegangen ist.",
  "shipment.cmrSigned": "Unterschriebener CMR",
  "shipment.packingSlip": "Lieferschein",
  "shipment.slipStoring": "wird gespeichert…",
  "shipment.slipHelp": "Eine PDF bis 10 MB, höchstens zwei pro Sendung, bis die Sendung entladen ist.",
  "shipment.slipClosed": "Diese Sendung ist bereits entladen: Ein Lieferschein kann nicht mehr hinzugefügt werden.",
  "shipment.cmrReceived": "eingegangen {{day}}",
  "shipment.download": "Herunterladen",

  "shipments.views": "Welche Sendungen",
  "shipments.view.active": "Aktiv",
  "shipments.view.waiting": "Wartet auf Willems",
  "shipments.view.delivered": "Zugestellt",
  "shipments.view.all": "Alle",
  "shipments.search": "Referenz, Auftragsnummer oder Ort",
  "shipments.periodFrom": "Von",
  "shipments.periodTo": "Bis einschließlich",
  "shipments.excel": "Excel",
  "shipments.col.shipment": "Sendung",
  "shipments.col.from": "Von",
  "shipments.col.to": "Nach",
  "shipments.col.load": "Laden",
  "shipments.col.unload": "Entladen",
  "shipments.col.cargo": "Ladung",
  "shipments.col.status": "Status",
  "shipments.col.cmr": "CMR",
  "shipments.pallets_one": "{{n}} Palette",
  "shipments.pallets_other": "{{n}} Paletten",
  "shipments.cmrNotYet": "noch nicht",
  "shipments.cmrNotYetLong": "CMR noch nicht eingegangen",
  "shipments.cmrAvailable": "CMR",
  "shipments.cmrAvailableLong": "CMR eingegangen",
  "shipments.cmrDownload": "Unterschriebenen CMR von {{number}} herunterladen",
  "shipments.pickOne": "{{number}} auswählen",
  "shipments.pickAll": "Alle Sendungen der Liste auswählen",
  "shipments.selected_one": "{{count}} ausgewählt",
  "shipments.selected_other": "{{count}} ausgewählt",
  "shipments.selectedWithCmr_one": "{{count}} mit CMR",
  "shipments.selectedWithCmr_other": "{{count}} mit CMR",
  "shipments.downloadCmrs": "CMRs herunterladen",
  "shipments.clearSelection": "Auswahl aufheben",
  "shipments.cmrZipMax": "Höchstens {{max}} CMRs auf einmal; bitte weniger auswählen.",
  "shipments.more": "Mehr anzeigen",
  "shipments.loadingMore": "Mehr wird geladen …",
  "shipments.notFound": "Nichts gefunden für „{{q}}“ in {{view}}",
  "shipments.notFoundText": "Suchen Sie in Alle, um auch zugestellte und stornierte Sendungen einzubeziehen.",
  "shipments.notFoundAll": "Versuchen Sie ein anderes Wort oder einen anderen Zeitraum.",
  "shipments.searchAll": "In Alle suchen",
  "columns.sortBy": "Nach {{column}} sortieren",
  "columns.filterBy": "Nach {{column}} filtern",
  "columns.filteredBy": "Gefiltert nach {{column}}: klicken, um den Filter zu ändern",
  "columns.filterContains": "Enthält…",
  "columns.filterRangeFrom": "Von",
  "columns.filterRangeTo": "Bis einschließlich",
  "columns.filterFrom": "ab {{value}}",
  "columns.filterUntil": "bis {{value}}",
  "columns.filterClear": "Löschen",
  "columns.filterDone": "Fertig",
  "columns.filteredOn": "Gefiltert nach",
  "columns.filterRemove": "Filter nach {{column}} entfernen",
  "columns.filterClearAll": "Alle Filter löschen",
  "shipments.palletsUnit": "Paletten",
  "shipments.notFiltered": "Keine Sendungen mit diesen Filtern in {{view}}",
  "shipments.notFilteredText": "Entfernen Sie einen Filter, oder schauen Sie unter Alle.",
  "shipments.emptyTitle": "Noch keine Sendungen",
  "shipments.emptyText": "Ein Auftrag, den Sie hier erfassen oder der per EDI eingeht, erscheint hier, sobald Willems ihn hat.",
  "shipments.none.active": "Keine Sendungen unterwegs oder geplant",
  "shipments.none.waiting": "Nichts wartet auf Willems",
  "shipments.none.delivered": "In diesem Zeitraum nichts zugestellt",
  "shipments.none.all": "Keine Sendungen in diesem Zeitraum",


  "shipment.entered.portalBy": "Im Portal erfasst von {{name}}, {{at}}",
  "order.steps": "Schritte",
  "order.step.stops": "Be- und Entladung",
  "order.step.goods": "Ladung",
  "order.step.documents": "Dokumente",
  "order.step.check": "Prüfen",
  "order.step.toFill": "noch auszufüllen",
  "order.step.willWait": "wartet auf Willems",
  "order.step.willConfirm": "sofort bestätigt",
  "order.step.more_one": "noch {{count}} Sendung",
  "order.step.more_other": "noch {{count}} Sendungen",
  "order.step.lines_one": "{{count}} Position",
  "order.step.lines_other": "{{count}} Positionen",
  "order.step.cmrDefault": "Ihr Unternehmen und die Entladeadresse",
  "order.step.slips_one": "{{count}} Lieferschein",
  "order.step.slips_other": "{{count}} Lieferscheine",
  "order.step.cmrOther": "anderer Absender oder Empfänger",
  "order.titleChange": "Auftrag {{number}} ändern",
  "order.forCompany": "Für {{company}}",
  "order.reference": "Ihre Referenz",
  "order.referenceHelp": "Steht auf dem CMR und der Rechnung.",
  "order.required": "Bitte ausfüllen.",
  "order.optional": "(optional)",
  "order.consignmentN": "Sendung {{n}}",
  "order.missing.stops": "Wählen Sie für Laden und Entladen eine Adresse und ein Datum; Entladen ist nicht vor dem Laden.",
  "order.missing.address": "Wählen Sie oben eine Adresse.",
  "order.missing.addressTyped": "Geben Sie mindestens den Namen, den Ort und das Land an.",
  "order.missing.date": "Wählen Sie ein Datum.",
  "order.missing.beforeLoad": "Entladen ist nicht vor dem Laden.",
  "order.missing.goods": "Geben Sie bei jeder Position eine Anzahl an, und die Lademeter bei Rollcontainern, Kartons und sonstigen Waren. Eine Beschreibung ist willkommen, aber nicht erforderlich.",
  "order.address.name": "Name",
  "order.address.street": "Straße",
  "order.address.houseNumber": "Hausnummer",
  "order.address.addition": "Zusatz",
  "order.address.postalCode": "Postleitzahl",
  "order.address.city": "Ort",
  "order.address.country": "Land",
  "order.address.fromBook": "Aus Ihren Adressen wählen",
  "order.address.other": "Eine andere Adresse wählen",
  "order.address.search_one": "In Ihrer {{count}} Adresse suchen",
  "order.address.search_other": "In Ihren {{count}} Adressen suchen",
  "order.address.new": "Andere Adresse",
  "order.address.all_one": "Alle {{count}} Adressen",
  "order.address.all_other": "Alle {{count}} Adressen",
  "order.address.mostUsed": "meistgenutzte zuerst",
  "order.address.noneFound": "Keine Ihrer Adressen passt zu Ihrer Suche.",
  "order.hours.always": "immer geöffnet",
  "order.hours.open": "geöffnet {{hours}}",
  "order.hours.closed": "an dem Tag geschlossen",
  "order.stop.load": "Laden",
  "order.stop.unload": "Entladen",
  "order.stop.newChip": "Neue Adresse",
  "order.stop.newShort": "neu",
  "order.stop.newWarning": "Neue Adresse: Ihr Auftrag wartet auf Willems. Willems prüft eine neue Adresse zuerst und legt sie an; danach geht der Auftrag weiter.",
  "order.stop.date": "Datum",
  "order.stop.from": "Zeitfenster von",
  "order.stop.to": "bis",
  "order.stop.endsBeforeStart": "Die Endzeit liegt vor der Startzeit. Ändern Sie die Zeit, oder kreuzen Sie unten an, dass das Zeitfenster bis zum nächsten Tag läuft.",
  "order.stop.nextDay": "Das Zeitfenster läuft bis zum nächsten Tag",
  "order.stop.loadReference": "Referenz beim Laden",
  "order.stop.unloadReference": "Referenz beim Entladen",
  "order.stop.requirement": "Transportanforderung",
  "order.stop.requirementNone": "Keine",
  "order.stop.instruction": "Bemerkung für den Fahrer",
  "order.stop.contactName": "Ansprechpartner",
  "order.stop.contactPhone": "Telefon",
  "order.stopRequirement.tail_lift": "Ladebordwand",
  "order.stopRequirement.rigid_with_tail_lift": "Motorwagen mit Ladebordwand",
  "order.stopRequirement.no_rear_tail_lift": "Keine Heckladebordwand",
  "order.note.outside_hours": "Das Zeitfenster liegt außerhalb der Öffnungszeiten ({{hours}}). Willems prüft das; der Auftrag geht weiter.",
  "order.note.closed_that_day": "Dieser Ort ist an dem Tag geschlossen. Willems prüft das; der Auftrag geht weiter.",
  "order.note.window_in_past": "Dieser Tag ist bereits vorbei.",
  "order.goods.titleTo": "Ladung nach {{place}}",
  "order.goods.count": "Anzahl",
  "order.goods.carrier": "Ladungsträger",
  "order.goods.description": "Warenbeschreibung",
  "order.goods.weight": "Gewicht (kg)",
  "order.goods.loadingMeters": "Lademeter",
  "order.goods.removeLine": "Position entfernen",
  "order.goods.addLine": "Noch eine Position",
  "order.goods.requirements": "Transportanforderungen",
  "order.goods.together": "Zusammen",
  "order.goods.pallets_one": "{{n}} Palette",
  "order.goods.pallets_other": "{{n}} Paletten",
  "order.goods.metres": "{{n}} Lademeter",
  "order.goods.volume": "Volumen (m³)",
  "order.goods.volumeValue": "{{n}} m³",
  "order.goods.adrCode": "ADR-Code",
  "order.goods.adrCodeChoose": "Wählen Sie den ADR-Code",
  "order.goods.adrClass": "Klasse {{value}}",
  "order.goods.adrPackingGroup": "Verpackungsgruppe",
  "order.goods.adrLines": "Gefahrgut (ADR)",
  "order.goods.adrPackingGroupChoose": "Wählen",
  "order.goods.adrQuantity": "Menge",
  "order.goods.adrUnit": "Einheit",
  "order.goods.adrAddLine": "Weiterer ADR-Stoff",
  "order.goods.adrRemoveLine": "Zeile entfernen",
  "order.goods.addConsignment": "Noch eine Sendung in diesem Auftrag, an eine andere Adresse",
  "order.goods.removeConsignment": "Sendung entfernen",
  "order.carrier.europallet": "Europalette",
  "order.carrier.block_pallet": "Industriepalette 0,5 LM",
  "order.carrier.block_pallet_06": "Industriepalette 0,6 LM",
  "order.carrier.block_pallet_09": "Industriepalette 0,9 LM",
  "order.carrier.ibc_02": "IBC 0,2 LM",
  "order.carrier.ibc_04": "IBC 0,4 LM",
  "order.carrier.ibc": "IBC 0,5 LM",
  "order.carrier.ibc_06": "IBC 0,6 LM",
  "order.carrier.big_bag": "Big Bag 0,5 LM",
  "order.carrier.roll_container": "Rollcontainer",
  "order.carrier.box": "Packstücke oder Kartons",
  "order.carrier.other": "Sonstiges",
  "order.carrier.own": "Ihre Ladungsträger",
  "order.carrier.fixed": "Standard",
  "order.cmr.title": "Auf dem CMR",
  "order.cmr.lead": "Absender und Empfänger können von der Lade- und Entladeadresse abweichen.",
  "order.cmr.sender": "Absender",
  "order.cmr.consignee": "Empfänger",
  "order.cmr.yourCompany": "Ihr Unternehmen, wie Willems es kennt",
  "order.cmr.sameAsUnload": "Wie die Entladeadresse",
  "order.cmr.theUnloadAddress": "die Entladeadresse",
  "order.cmr.other": "Eine andere Adresse",
  "order.slip.label": "Lieferschein",
  "order.slip.help": "Eine PDF, zum Beispiel Ihr Lieferschein, bis 10 MB. Sie finden sie bei der Sendung wieder.",
  "order.slip.add": "Lieferschein hinzufügen",
  "order.slip.uploading": "Wird hinzugefügt…",
  "order.slip.remove": "{{name}} entfernen",
  "order.slip.tooLarge": "Diese Datei ist größer als 10 MB.",
  "order.slip.notPdf": "Als Lieferschein ist nur eine PDF möglich.",
  "order.slip.tooMany": "Höchstens {{max}} pro Sendung.",
  "order.slip.failed": "Das Hinzufügen hat nicht geklappt. Bitte versuchen Sie es erneut.",
  "order.slip.gone": "Ein Lieferschein lag uns nicht mehr vor. Bitte fügen Sie ihn erneut hinzu und senden Sie den Auftrag dann.",
  "order.check.title": "So geht der Auftrag an Willems",
  "order.check.change": "Ändern",
  "order.check.willWait": "Dieser Auftrag wartet auf Willems.",
  "order.rail.title": "Ihr Auftrag",
  "order.rail.step": "Schritt {{n}}",
  "order.rail.loadN": "Laden {{n}}",
  "order.rail.unloadN": "Entladen {{n}}",
  "order.rail.goods": "Ladung",
  "order.notice.title": "Bevor Sie senden",
  "order.notice.newAddress": "Neue Adresse: Der Auftrag wartet, bis Willems die Adresse geprüft hat.",
  "order.notice.inTime": "Rechtzeitig für das Laden am {{load}}: Erfassen ist möglich bis {{until}}.",
  "order.notice.late": "Nach dem Annahmeschluss ({{time}} am Tag vor dem Laden). Willems prüft, ob es noch klappt.",
  "order.notice.referenceTaken": "Ihre Referenz steht bereits auf Auftrag {{order}}. Bitte wählen Sie eine andere.",
  "order.savedAt": "Entwurf gespeichert um {{time}}",
  "order.notSavedYet": "Wird beim Tippen gespeichert",
  "order.saveAndClose": "Speichern und schließen",
  "order.previous": "Zurück",
  "order.next": "Weiter: {{step}}",
  "order.send": "Auftrag senden",
  "order.sendChange": "Änderung senden",
  "order.sendAgain": "Erneut senden",
  "order.sending": "Wird gesendet …",
  "order.failure.title": "Senden hat nicht geklappt",
  "order.failure.text": "Ihr Auftrag wurde nicht gesendet; Ihre Eingaben sind noch da. Bitte versuchen Sie es erneut. Klappt es nicht, wenden Sie sich an Ihren Ansprechpartner.",
  "order.failure.textCode": "Ihr Auftrag wurde nicht gesendet; Ihre Eingaben sind noch da. Bitte versuchen Sie es erneut. Klappt es nicht, nennen Sie Ihrem Ansprechpartner den Code {{code}}.",
  "order.error.too_many_pallets": "Mehr als 99 Palettenstellplätze in einer Sendung. Verteilen Sie die Ladung auf mehrere Sendungen.",
  "order.error.too_heavy": "Mehr als 60.000 kg in einer Sendung. Verteilen Sie die Ladung auf mehrere Sendungen.",
  "order.error.too_long": "Mehr als 30 Lademeter in einer Sendung. Verteilen Sie die Ladung auf mehrere Sendungen.",
  "order.sent.at": "Gesendet um {{time}}",
  "order.sent.changedAt": "Geändert um {{time}}",
  "order.sent.title": "Auftrag {{number}} ist bei Willems",
  "order.sent.changedTitle": "Auftrag {{number}} wurde geändert",
  "order.sent.confirmed": "Willems hat den Auftrag und plant ihn ein.",
  "order.sent.toShipment": "Zur Sendung",
  "order.sent.another": "Noch einen Auftrag erfassen",
  "order.sent.sameAgain": "Derselbe Auftrag für einen anderen Tag",
  "order.earlier.open": "Mit einem früheren Auftrag beginnen",
  "order.earlier.title": "Mit einem früheren Auftrag beginnen",
  "order.earlier.lead": "Das Portal übernimmt Adressen, Zeitfenster, Ladung und Transportanforderungen. Die Daten und Ihre Referenz geben Sie selbst ein.",
  "order.earlier.search": "Suche nach Auftrag, Ihrer Referenz oder Ort",
  "order.earlier.order": "Auftrag",
  "order.earlier.route": "Route",
  "order.earlier.take": "Diesen nehmen",
  "order.earlier.none": "Keine Aufträge gefunden.",
  "order.notAvailable": "Aufträge erfassen können im Portal Kunden von Willems. Bitte wenden Sie sich an Ihren Ansprechpartner.",
  "order.notChangeable.closed": "Dieser Auftrag wurde abgelehnt oder storniert und kann nicht mehr geändert werden.",
  "order.notChangeable.elsewhere": "Dieser Auftrag wurde nicht im Portal erfasst. Ändern Sie ihn auf dem Weg, auf dem er kam, oder über Ihren Ansprechpartner bei Willems.",
  "order.notChangeable.planned": "Dieser Auftrag ist eingeplant. Ändern geht jetzt nur über Ihren Ansprechpartner bei Willems.",
  "order.notChangeable.pending": "Willems bearbeitet noch eine Änderung dieses Auftrags. Versuchen Sie es später erneut oder wenden Sie sich an Ihren Ansprechpartner.",
  "order.notChangeable.transition": "Dieser Auftrag wurde vor dem 1. Dezember erfasst. Ändern oder stornieren können Sie ihn über Ihren Ansprechpartner bei Willems.",
  "order.change": "Ändern",
  "order.changeUntil": "Möglich, bis die Sendung eingeplant ist.",
  "order.again": "Für einen anderen Tag erneut erfassen",
  "order.cancel.open": "Stornieren",
  "order.cancel.title": "Auftrag {{number}} stornieren",
  "order.cancel.lead": "Der ganze Auftrag wird storniert, mit allen Sendungen. Willems liest Ihren Grund.",
  "order.cancel.reason": "Warum stornieren Sie?",
  "order.cancel.back": "Zurück",
  "order.cancel.confirm": "Auftrag stornieren",
  "order.cancel.tooLate": "Dieser Auftrag kann im Portal nicht mehr storniert werden. Bitte wenden Sie sich an Ihren Ansprechpartner.",

  "error.loginFailed":
    "E-Mail-Adresse oder Passwort stimmt nicht. Achten Sie auf Groß- und Kleinschreibung. Nach fünf Versuchen ist die Anmeldung eine Viertelstunde gesperrt.",
  "error.locked": "Ihr Konto ist nach fünf falschen Versuchen eine Viertelstunde gesperrt. Es geht wieder um {{time}}.",
  "error.codeWrong": "Dieser Code stimmt nicht. Geben Sie den Code ein, der jetzt in der App steht.",
  "error.setupIncomplete":
    "Ihr Konto ist noch nicht eingerichtet. Verwenden Sie den Link in der Einladung; funktioniert er nicht mehr, bitten Sie Ihren Ansprechpartner bei Willems um einen neuen.",
  "error.linkInvalid": "Dieser Link funktioniert nicht mehr.",
  "error.currentPasswordWrong": "Dieses Passwort stimmt nicht.",
  "error.signInAgain": "Das hat zu lange gedauert. Bitte melden Sie sich erneut an.",
  "error.secondFactorOff": "Die Verbindung mit der App ist hier noch nicht möglich. Wenden Sie sich an Ihren Ansprechpartner bei Willems.",
  "error.tooMany": "Zu viele Versuche von dieser Adresse. Warten Sie eine Minute und versuchen Sie es erneut.",
  "error.generic": "Etwas ist schiefgegangen. Bitte versuchen Sie es gleich noch einmal.",

  // Voorraad (H-v01 … H-v06, step 7).
  "stock.asOf": "Stand von",
  "stock.inWarehouse": "Lager {{name}}",
  "stock.inWarehouses_one": "{{count}} Lager",
  "stock.inWarehouses_other": "{{count}} Lager",
  "stock.fetching": "Bestand wird abgerufen",
  "stock.noStand": "Kein Bestand",
  "stock.refresh": "Aktualisieren",
  "stock.excel": "Excel pro Palette",
  "stock.views": "Welche Artikel",
  "stock.view.all": "Alle Artikel",
  "stock.view.short": "MHD unter 9 Monaten",
  "stock.view.blocked": "Gesperrt",
  "stock.search": "Artikel, Charge, SSCC oder LHC",
  "stock.searchShort": "Artikel suchen",
  "stock.owner": "Eigentümer",
  "stock.allOwners": "Alle Eigentümer",
  "stock.warehouse": "Lager",
  "stock.allWarehouses": "Alle Lager",
  "stock.loading": "Der Bestand wird aus dem Lager abgerufen. Das dauert einige Sekunden.",
  "stock.failedTitle": "Der Bestand kann gerade nicht abgerufen werden.",
  "stock.failedText": "Bitte versuchen Sie es in einigen Minuten erneut. Einen älteren Stand zeigen wir nicht: Er stimmt möglicherweise nicht mehr.",
  "stock.failedCode": "Klappt es weiterhin nicht? Nennen Sie Ihrem Ansprechpartner bei Willems den Code {{code}}.",
  "stock.busyTitle": "Gerade ist viel los.",
  "stock.busyText": "Im Moment wird viel Bestand abgefragt. Bitte versuchen Sie es in einer Minute erneut.",
  "stock.refreshIn": "Aktualisieren in {{seconds}} s",
  "stock.retryIn": "Erneut in {{seconds}} s",
  "stock.emptyTitle": "Sie haben derzeit keinen Bestand bei Willems.",
  "stock.emptyText": "Sobald Paletten eingehen, erscheinen sie hier.",
  "stock.notFound": "Nichts gefunden für „{{q}}“.",
  "stock.none.all": "Keine Artikel mit diesen Filtern.",
  "stock.none.short": "Keine Paletten mit einem MHD unter 9 Monaten.",
  "stock.none.blocked": "Keine gesperrten Paletten.",
  "stock.showAll": "Alles anzeigen",
  "stock.col.article": "Artikel",
  "stock.col.total": "Gesamt",
  "stock.col.free": "Frei",
  "stock.col.reserved": "Reserviert",
  "stock.col.blocked": "Gesperrt",
  "stock.col.shortest": "MHD (kürzestes)",
  "stock.col.bestBefore": "MHD",
  "stock.col.sscc": "SSCC",
  "stock.col.batch": "Charge",
  "stock.col.lhc": "LHC",
  "stock.col.quantity": "Menge",
  "stock.col.status": "Status",
  "stock.col.received": "Eingegangen",
  "stock.shortPallets_one": "{{count}} Palette < 9 Mon.",
  "stock.shortPallets_other": "{{count}} Paletten < 9 Mon.",
  "stock.months_one": "{{count}} Mon.",
  "stock.months_other": "{{count}} Mon.",
  "stock.palletsWhere": "in {{where}} · gesperrte zuerst, dann das kürzeste MHD",
  "stock.status.free": "Frei",
  "stock.status.reserved": "Reserviert",
  "stock.status.blocked": "Gesperrt",
  "stock.split": "Frei {{free}}, reserviert {{reserved}}, gesperrt {{blocked}}",
  "stock.freeShort": "Frei {{n}}",
  "stock.reservedShort": "Res. {{n}}",
  "stock.blockedShort": "Gesp. {{n}}",

  // Uitleveren en Aanleveren (H-w01 … H-w03, step 8).
  "warehouseOrder.kindLabel": "Art des Auftrags",
  "warehouseOrder.kind.transport": "Nur Transport",
  "warehouseOrder.kind.outbound": "Auslieferung aus unserem Lager",
  "warehouseOrder.kind.inbound": "Anlieferung in unser Lager",
  "warehouseOrder.kindShort.transport": "Transport",
  "warehouseOrder.kindShort.outbound": "Auslieferung",
  "warehouseOrder.kindShort.inbound": "Anlieferung",
  "warehouseOrder.loading": "Ihre Artikel und Lager werden abgerufen.",
  "warehouseOrder.noWarehouse": "Sie haben derzeit keinen Bestand bei Willems.",
  "warehouseOrder.noWarehouseText": "Möchten Sie einen neuen Artikel anliefern? Wenden Sie sich an Ihren Ansprechpartner bei Willems.",
  "warehouseOrder.articles": "Artikel",
  "warehouseOrder.ownArticles_one": "{{count}} Ihrer Artikel",
  "warehouseOrder.ownArticles_other": "{{count}} Ihrer Artikel",
  "warehouseOrder.unit": "Einheit",
  "warehouseOrder.uom.PCE_one": "Stück",
  "warehouseOrder.uom.PCE_other": "Stück",
  "warehouseOrder.uom.ST_one": "Stück",
  "warehouseOrder.uom.ST_other": "Stück",
  "warehouseOrder.uom.CT_one": "Karton",
  "warehouseOrder.uom.CT_other": "Kartons",
  "warehouseOrder.uom.BX_one": "Karton",
  "warehouseOrder.uom.BX_other": "Kartons",
  "warehouseOrder.uom.BG_one": "Sack",
  "warehouseOrder.uom.BG_other": "Säcke",
  "warehouseOrder.uom.BD_one": "Bund",
  "warehouseOrder.uom.BD_other": "Bunde",
  "warehouseOrder.uom.KT_one": "Kit",
  "warehouseOrder.uom.KT_other": "Kits",
  "warehouseOrder.uom.PF_one": "Palette",
  "warehouseOrder.uom.PF_other": "Paletten",
  "warehouseOrder.uom.KGM_one": "Kilo",
  "warehouseOrder.uom.KGM_other": "Kilo",
  "warehouseOrder.stockAsOf": "Bestand: Stand von {{time}}",
  "warehouseOrder.stockFailed": "Der Bestand kann gerade nicht abgerufen werden. Sie können die Artikelnummer selbst eingeben.",
  "warehouseOrder.stockLoading": "Bestand wird abgerufen…",
  "warehouseOrder.chooseOwner": "Eigentümer wählen",
  "warehouseOrder.article": "Artikel",
  "warehouseOrder.searchArticle": "Artikelnummer oder Bezeichnung eingeben",
  "warehouseOrder.noArticleFound": "Kein Artikel gefunden",
  "warehouseOrder.moreArticles_one": "Noch {{count}} Artikel: weiter tippen, um zu suchen",
  "warehouseOrder.moreArticles_other": "Noch {{count}} Artikel: weiter tippen, um zu suchen",
  "warehouseOrder.freeShort": "frei {{n}} {{unit}}",
  "warehouseOrder.notListed": "Kein Artikel aus der Liste: bitte den Artikel wählen",
  "warehouseOrder.quantity": "Menge {{unit}}",
  "warehouseOrder.batch": "Charge",
  "warehouseOrder.pallets": "Paletten",
  "warehouseOrder.choosePallets": "Paletten wählen",
  "warehouseOrder.palletsChosen_one": "{{count}} Palette",
  "warehouseOrder.palletsChosen_other": "{{count}} Paletten",
  "warehouseOrder.palletsHint": "Kreuzen Sie die Paletten an, die ausgeliefert werden sollen. Die Menge ist, was darauf steht.",
  "warehouseOrder.palletsHintBatch": "Kreuzen Sie die Paletten der Charge {{batch}} an, die ausgeliefert werden sollen. Die Menge ist, was darauf steht.",
  "warehouseOrder.noPalletsOfBatch": "Es gibt keine freien Paletten dieser Charge.",
  "warehouseOrder.palletNumber": "Paletten-Nr. {{n}}",
  "warehouseOrder.bestBefore": "MHD {{date}}",
  "warehouseOrder.perPallet": "Je Palette",
  "warehouseOrder.removeLine": "Entfernen",
  "warehouseOrder.moreThanFree": "Mehr als frei ist ({{free}} {{unit}}). Sie können trotzdem senden; Willems meldet sich bei Ihnen.",
  "warehouseOrder.addLine": "Artikel hinzufügen",
  "warehouseOrder.howOut": "Wie verlässt es {{warehouse}}?",
  "warehouseOrder.howIn": "Wie kommt es nach {{warehouse}}?",
  "warehouseOrder.transport.outbound.willems": "Willems liefert es aus",
  "warehouseOrder.transport.outbound.customer": "Es wird abgeholt",
  "warehouseOrder.transport.inbound.willems": "Willems holt es ab",
  "warehouseOrder.transport.inbound.customer": "Es wird angeliefert",
  "warehouseOrder.dayOut": "Tag, an dem es unser Lager verlässt",
  "warehouseOrder.dayIn": "Tag der Ankunft",
  "warehouseOrder.load": "Was transportiert wird",
  "warehouseOrder.remark": "Hinweis für das Lager",
  "warehouseOrder.orderLabel": "Ihr Auftrag",
  "warehouseOrder.deliverTo": "Zustellen bei",
  "warehouseOrder.collectedAddressHint": "Wohin gehen die Waren? Das steht auf dem Frachtbrief (CMR).",
  "warehouseOrder.collectFrom": "Abholen bei",
  "warehouseOrder.forWarehouse": "Für das Lager",
  "warehouseOrder.vas": "VAS",
  "warehouseOrder.vasOrder": "VAS für den ganzen Auftrag",
  "warehouseOrder.vasLine": "VAS für {{article}}",
  "warehouseOrder.vasChoose": "Wählen",
  "warehouseOrder.beforeSending": "Bevor Sie senden: Für {{articles}} fragen Sie mehr an, als frei ist. Willems meldet sich bei Ihnen.",
  "warehouseOrder.send": "Auftrag senden",
  "warehouseOrder.sending": "Wird gesendet…",
  "warehouseOrder.sent.title": "Auftrag {{number}} wurde gesendet",
  "warehouseOrder.sent.withTransport": "Das Lager stellt es bereit und Willems fährt es. Die Sendung verfolgen Sie unter Sendungen.",
  "warehouseOrder.sent.withoutTransport": "Das Lager hat Ihren Auftrag. Willems meldet sich bei Ihnen, falls etwas nicht stimmt.",
  "warehouseOrder.sent.toShipment": "Zur Sendung",
  "warehouseOrder.sent.another": "Noch ein Auftrag",
  "warehouseOrder.sent.toOrders": "Zu Ihren Lageraufträgen",

  "warehouseOrders.lead": "Ihre Auslieferungen und Anlieferungen der letzten 90 Tage, auch was abgeholt oder gebracht wird.",
  "warehouseOrders.loading": "Ihre Lageraufträge werden abgerufen.",
  "warehouseOrders.views": "Welche Aufträge",
  "warehouseOrders.view.all": "Alle",
  "warehouseOrders.view.outbound": "Auslieferung",
  "warehouseOrders.view.inbound": "Anlieferung",
  "warehouseOrders.search": "Referenz, Auftragsnummer oder Artikel",
  "warehouseOrders.searchShort": "Suchen",
  "warehouseOrders.col.order": "Ihre Referenz",
  "warehouseOrders.col.kind": "Art",
  "warehouseOrders.col.warehouse": "Lager",
  "warehouseOrders.col.day": "Tag",
  "warehouseOrders.col.transport": "Transport",
  "warehouseOrders.col.articles": "Artikel",
  "warehouseOrders.col.status": "Status",
  "warehouseOrders.col.quantity": "Menge",
  "warehouseOrders.col.pallet": "Palette",
  "warehouseOrders.moreArticles_one": "und {{count}} weiterer Artikel",
  "warehouseOrders.moreArticles_other": "und {{count}} weitere Artikel",
  "warehouseOrders.status.sent": "Gesendet",
  "warehouseOrders.status.received": "Beim Lager",
  "warehouseOrders.status.waiting": "Willems prüft ihn",
  "warehouseOrders.deliveryDay": "Gewünschter Liefertag",
  "warehouseOrders.goesTo": "Geht nach",
  "warehouseOrders.enteredPortal": "Im Portal erfasst am {{at}}",
  "warehouseOrders.enteredWillems": "Von Willems erfasst am {{at}}",
  "warehouseOrders.emptyTitle": "Noch keine Lageraufträge",
  "warehouseOrders.emptyText": "Eine Auslieferung oder Anlieferung, die Sie erfassen, steht hier.",
  "warehouseOrders.notFound": "Nichts gefunden für „{{q}}“",
  "warehouseOrders.none.all": "Keine Lageraufträge",
  "warehouseOrders.none.outbound": "Keine Auslieferungen",
  "warehouseOrders.none.inbound": "Keine Anlieferungen",
  "warehouseOrders.transport.willems": "Mit Willems",
  "warehouseOrders.transport.customer": "Abgeholt oder gebracht",
  "warehouseOrders.notFiltered": "Keine Lageraufträge mit diesen Filtern",
  "warehouseOrders.showAll": "Alle anzeigen",
};
